export enum ValidationState {
  Idle = "idle",
  Success = "success",
  Error = "error",
}

export enum PreviewType {
  WIDGET = "widget",
  BORROWER_PLATFORM = "borrower-platform",
}
